import React from 'react'

import Header from '../../components/Header'
import { Button } from '@harvey-frontend/components/ui/button'

type ErrorScreenProps = {
  error: string
  retry: () => void
}

export const ErrorScreen = ({ error, retry }: ErrorScreenProps) => {
  return (
    <div className="flex h-screen flex-col">
      <Header title="Choose playbook" isDisabled />
      <div className="flex flex-1 flex-col items-center justify-center gap-4 px-4">
        <div className="flex w-[250px] flex-col items-center gap-1">
          <p className="text-sm font-medium text-primary">
            Playbook processing issue
          </p>
          <p className="text-center text-xs text-muted">
            There was an issue running your playbook.
          </p>
          <p className="text-center text-xs text-muted">
            <span className="text-xs font-medium">Error message: </span>
            {error}
          </p>
        </div>
        <Button size="sm" onClick={retry}>
          Try again
        </Button>
      </div>
      <div className="flex w-full justify-start p-4">
        <Button variant="outline" size="sm" onClick={retry}>
          Cancel
        </Button>
      </div>
    </div>
  )
}

export default ErrorScreen
